// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"html__wrapper__QC49G","asterisk":"html__asterisk__4uPJj","background":"html__background__TVNe4"};